import { Budget } from "../types";
import { IBudgetKanbanItem } from "../../../models/budget";

export const mapApiBudgetToBudget = (apiBudget: IBudgetKanbanItem, persona?: string): Budget => {
  const formatDate = (dateString?: string): string => {
    if (!dateString) return "";
    try {
      let date: Date;
      const hasTimezone = dateString.includes('Z') || dateString.match(/[+-]\d{2}:\d{2}$/) || dateString.match(/[+-]\d{4}$/);
      
      if (hasTimezone) {
        date = new Date(dateString);
      } else {
        date = new Date(dateString + 'Z');
      }
      
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = String(date.getFullYear()).slice(-2);
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${day}/${month}/${year} - ${hours}:${minutes}`;
    } catch {
      return dateString;
    }
  };

  const mapStatus = (status: string): Budget["status"] => {
    const statusMap: Record<string, Budget["status"]> = {
      "Pendente": "pendente",
      "Aprovado": "aceito",
      "Enviado": "enviado",
      "Alterado": "alterado",
      "Contraproposta": "contraproposta",
      "Recusado": "recusado",
      "Concluído": "concluido",
      SENT: "enviado",
      PENDING: "alterado",
      COUNTER_PROPOSED: "contraproposta",
      APPROVED: "aceito",
      APPROVED_BY_FACTORY: "aceito",
      REJECTED: "recusado",
    };
    return statusMap[status] || "pendente";
  };

  const mapColumn = (status: string, kanbanStep?: string, persona?: string): Budget["column"] => {
    const isManager = persona === "MANAGER";
    
    if (isManager) {
      const statusLower = status.toLowerCase();
      if (statusLower === "aprovado" || statusLower === "approved") {
        return "aceito";
      }
      if (statusLower === "recusado" || statusLower === "rejected") {
        return "recusado";
      }
      return "enviado";
    }
    
    if (kanbanStep) {
      if (kanbanStep === "IN_REVIEW") {
        return "pendente";
      }
      if (kanbanStep === "PENDING") {
        return "enviado";
      }
      if (kanbanStep === "ACCEPTED") {
        return "concluido";
      }
    }
    
    const statusLower = status.toLowerCase();
    if (statusLower === "aprovado" || statusLower === "approved" || statusLower === "concluído" || statusLower === "completed") {
      return "concluido";
    }
    if (statusLower === "enviado" || statusLower === "sent") {
      return "enviado";
    }
    
    return "pendente";
  };

  const mapRecipient = (recipient: string): "Consultor da concessionária" | "Volks|total" | "Gestor de Frotas" | "Não identificado" => {
    if (recipient === "FACTORY") {
      return "Volks|total";
    }
    if (recipient === "CONSULTANT") {
      return "Consultor da concessionária";
    }
    if (recipient === "MANAGER") {
      return "Gestor de Frotas";
    }
    return "Não identificado";
  };

  return {
    id: apiBudget.uuid,
    budgetNumber: apiBudget.budgetNumber,
    recipient: mapRecipient(apiBudget.recipient),
    date: formatDate(apiBudget.updatedAt),
    version: `v ${apiBudget.lastVersionNumber}.0`,
    status: mapStatus(apiBudget.status),
    column: mapColumn(apiBudget.status, apiBudget.kanbanStep, persona),
    consultant: apiBudget.consultant || "Não identificado",
    customerName: apiBudget.customerName || "Não identificado",
    chassis: apiBudget.vehicleChassis || "Não identificado",
  };
};
